import React from "react";
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from "@headlessui/react";

interface DynamicTabsProps {
    tabs: TabDefinition[];
    selectedTabIndex?: number;
    setSelectedTabIndex: (index: number) => void;
}

export interface TabDefinition {
    name: string;
    slug: string;
    icon: React.ReactNode;
    description: string;
    component: React.ComponentType;
}

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
}

export const SamTabedPage: React.FC<DynamicTabsProps> = ({
                                                             tabs,
                                                             selectedTabIndex,
                                                             setSelectedTabIndex,
                                                         }) => {

    return (

        <TabGroup selectedIndex={selectedTabIndex} onChange={setSelectedTabIndex}>
            {/* Mobile dropdown */}
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                <select
                    id="tabs"
                    className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    value={selectedTabIndex}
                    onChange={(e) => setSelectedTabIndex(Number(e.target.value))}
                >
                    {tabs.map((tab, index) => (
                        <option key={tab.name} value={index}>
                            {tab.name}
                        </option>
                    ))}
                </select>
            </div>

            {/* Desktop tabs */}
            <div className="hidden sm:block">
                <TabList className="flex space-x-1 rounded-xl bg-white p-1.5 border border-slate-200">
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.name}
                            className={({ selected }) =>
                                classNames(
                                    'w-full rounded-lg py-3 text-sm font-medium leading-5',
                                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2 hover:cursor-pointer',
                                    selected
                                        ? 'bg-slate-50 text-slate-900 shadow-sm'
                                        : 'text-slate-600 hover:bg-slate-50/[0.5] hover:text-slate-900'
                                )
                            }
                        >
                            <div className="flex items-center justify-center space-x-2">
                                {tab.icon}
                                <span>{tab.name}</span>
                            </div>
                        </Tab>
                    ))}
                </TabList>
            </div>

            {/* Content panels */}
            <TabPanels className="mt-6">
                {tabs.map((tab, idx) => {
                    const TabComponent = tab.component;
                    return (
                        <TabPanel
                            key={idx}
                            className={classNames(
                                'rounded-xl bg-white p-6',
                                'border border-slate-200'
                            )}
                        >
                            {/* Optional wrapper for consistent layout */}
                            <div>
                                {tab.description && (
                                    <div className="mb-4">
                                        <h2 className="text-xl font-semibold text-slate-800">{tab.name}</h2>
                                        <p className="text-slate-600">{tab.description}</p>
                                    </div>
                                )}
                                <TabComponent />
                            </div>
                        </TabPanel>
                    );
                })}
            </TabPanels>
        </TabGroup>

    );
};